import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { Observable } from 'rxjs';
import { InputNumberModule } from 'primeng/inputnumber';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'sm-budget-estimate',
  imports: [CommonModule, FormsModule, InputGroupModule, InputGroupAddonModule, InputNumberModule, TranslateModule],
  templateUrl: './budget-estimate.component.html',
  styleUrl: './budget-estimate.component.scss',
})
export class BudgetEstimateComponent {
  @Input() label?: string;
  @Input() value?: Observable<number>;
}
